"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _reactRedux = require("react-redux");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _uuid = require("uuid");

var _services = require("@alycecom/services");

var _query = require("@reduxjs/toolkit/query");

var _prospectingContacts = require("../../../constants/prospectingContacts.schemas");

var _uploadProspectingContacts = require("../../../constants/uploadProspectingContacts.constants");

var _useTrackGiftingFlow = require("../../../../../hooks/useTrackGiftingFlow");

var _createBatchStep = require("../../../../../store/ui/createBatchStep");

var _commonData = require("../../../../../../Shared/store/commonData");

var _providers = require("../../../../../providers");

var _sendAs = require("../../../../../../CreateGift/store/send-as/send-as.actions");

var _user = require("../../../../../../Shared/store/user/user.selectors");

var _FirstNameCell = _interopRequireDefault(require("./cells/FirstNameCell"));

var _LastNameCell = _interopRequireDefault(require("./cells/LastNameCell"));

var _EmailCell = _interopRequireDefault(require("./cells/EmailCell"));

var _CompanyCell = _interopRequireDefault(require("./cells/CompanyCell"));

var _RemoveContactCell = _interopRequireDefault(require("./cells/RemoveContactCell"));

var _CountryCell = _interopRequireDefault(require("./cells/CountryCell"));

var _ContactsTableErrors = _interopRequireDefault(require("./ContactsTableErrors"));

var _CustomFieldCell = _interopRequireDefault(require("./cells/CustomFieldCell"));

var _SendAsCell = _interopRequireDefault(require("./cells/SendAsCell"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    table: {
      margin: spacing(2, 0, 0, 0),
      '& .ReactVirtualized__Table__rowColumn': {
        margin: 0,
        padding: spacing(0.9, 0.5, 0, 0.5),
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        justifyContent: 'start'
      },
      '& .ReactVirtualized__Table__headerColumn': {
        padding: spacing(1.5, 1.5)
      },
      '& .ReactVirtualized__Table__row': {
        flexWrap: 'wrap'
      },
      tableBottomShadow: {
        '&::after': {
          boxShadow: 'none'
        }
      }
    },
    bodyText: {
      color: palette.grey.main,
      fontSize: 16,
      lineHeight: 1.2
    },
    buttonAddContact: {
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: 'transparent'
      }
    }
  };
});
var styles = {
  buttonIcon: {
    paddingRight: '0.5em'
  }
};

var makeEmptyContact = function makeEmptyContact() {
  var override = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    id: (0, _uuid.v4)(),
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    country: '',
    sendAsEmail: ''
  }, override);
};

var ContactsTableController = function ContactsTableController(_ref2) {
  var _campaign$team;

  var control = _ref2.control,
      countries = _ref2.countries,
      _ref2$loading = _ref2.loading,
      isLoading = _ref2$loading === void 0 ? false : _ref2$loading;
  var dispatch = (0, _reactRedux.useDispatch)();
  var classes = useStyles();
  var currentUserEmail = (0, _reactRedux.useSelector)(_user.getUserEmail);

  var _useState = (0, _react.useState)(undefined),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      scrollToIndex = _useState2[0],
      setScrollIndex = _useState2[1];

  var trackGiftingFlowAddContactsButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowAddContactsButtonClicked)();
  var trackGiftingFlowRemoveContactButtonClicked = (0, _useTrackGiftingFlow.useGiftingFlowRemoveContactButtonClicked)();

  var _useFieldArray = (0, _reactHookForm.useFieldArray)({
    name: _prospectingContacts.ContactStepField.contacts,
    control: control
  }),
      fields = _useFieldArray.fields,
      append = _useFieldArray.append,
      remove = _useFieldArray.remove;

  var _useGiftingFlowContex = (0, _providers.useGiftingFlowContext)(),
      campaignId = _useGiftingFlowContex.campaignId;

  var _useGetCampaignByIdQu = (0, _services.useGetCampaignByIdQuery)(campaignId || _query.skipToken),
      campaign = _useGetCampaignByIdQu.data;

  var teamId = campaign === null || campaign === void 0 ? void 0 : (_campaign$team = campaign.team) === null || _campaign$team === void 0 ? void 0 : _campaign$team.id;
  (0, _react.useEffect)(function () {
    if (teamId) {
      dispatch((0, _sendAs.loadSendAsRequest)(teamId));
    }
  }, [dispatch, teamId]);
  var isTableEmpty = fields.length === 0;
  var isOneContactLeft = fields.length === 1;
  var isAddSingleContactDisable = fields.length >= _uploadProspectingContacts.BULK_CONTACTS_LIMIT;
  var customFields = (0, _reactRedux.useSelector)(_commonData.CommonData.selectors.getCustomFields);
  var gap = {
    name: 'gap',
    label: '',
    required: false,
    teams: []
  };
  var customFieldsWithGap = customFields.reduce(function (newFields, field, index) {
    if (index === 4) {
      newFields.push(gap);
    }

    if ((index + 1) % 5 === 0 && index > 5) {
      newFields.push(gap);
    }

    newFields.push(field);
    return newFields;
  }, []);
  var customFieldsObject = customFieldsWithGap.reduce(function (acc, field) {
    acc[field.name] = '';
    return acc;
  }, {});
  var getRowItem = (0, _react.useCallback)(function (_ref3) {
    var index = _ref3.index;
    return fields[index] || {};
  }, [fields]);
  var columnData = (0, _react.useMemo)(function () {
    return {
      control,
      isLoading,
      isOneContactLeft
    };
  }, [control, isLoading, isOneContactLeft]);
  var handleRemoveContact = (0, _react.useCallback)(function (index, contactInfo) {
    trackGiftingFlowRemoveContactButtonClicked(contactInfo);
    remove(index);
  }, [remove, trackGiftingFlowRemoveContactButtonClicked]);
  var handleAddSingleContact = (0, _react.useCallback)(function () {
    var preselectedCountry = countries.length === 1 ? countries[0].code : '';
    append(makeEmptyContact({
      country: preselectedCountry,
      customFields: customFieldsObject,
      sendAsEmail: currentUserEmail
    }));
    trackGiftingFlowAddContactsButtonClicked();
    setScrollIndex(fields.length);
  }, [currentUserEmail, fields.length, countries, append, setScrollIndex, trackGiftingFlowAddContactsButtonClicked, customFieldsObject]);
  (0, _react.useEffect)(function () {
    return function () {
      dispatch((0, _createBatchStep.setCreateBatchStep)(_createBatchStep.CreateBatchStep.FileUpload));
    };
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    if (isTableEmpty) {
      var preselectedCountry = countries.length === 1 ? countries[0].code : '';
      append(makeEmptyContact({
        country: preselectedCountry,
        customFields: customFieldsObject
      }));
    }
  }, [isTableEmpty, countries, append, customFieldsObject]);
  var fieldsCount = customFields ? Math.ceil(Object.keys(customFields).length / 5) : 0;
  var matchFn = customFields ? Math.max : Math.min;
  var customHeight = (matchFn(fieldsCount, 1) + 1) * 84;
  var tmpColumn = 1;

  var gapComponent = /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
    label: "Line",
    dataKey: "",
    width: 50,
    columnData: columnData,
    cellRenderer: function cellRenderer() {
      return /*#__PURE__*/_react.default.createElement(_material.Box, {
        display: "flex",
        alignItems: "center",
        height: 48
      }, "\xA0\xA0");
    }
  });

  return /*#__PURE__*/_react.default.createElement(_material.Box, null, /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
    disableHeight: true,
    style: {
      width: '100%'
    }
  }, function (_ref4) {
    var width = _ref4.width;
    return /*#__PURE__*/_react.default.createElement(_ui.VirtualizedTable, {
      className: classes.table,
      scrollToIndex: scrollToIndex,
      rowHeight: customHeight,
      maxVisibleRows: 4,
      headerHeight: 40,
      disableHeader: true,
      width: width,
      rowGetter: getRowItem,
      rowCount: fields.length
    }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Line",
      dataKey: "",
      width: 50,
      columnData: columnData,
      cellRenderer: function cellRenderer(_ref5) {
        var rowIndex = _ref5.rowIndex;
        return /*#__PURE__*/_react.default.createElement(_material.Box, {
          display: "flex",
          alignItems: "center",
          height: 48
        }, rowIndex + 1);
      }
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "First Name",
      dataKey: "firstName",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_FirstNameCell.default, props);
      }
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Last Name",
      dataKey: "lastName",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_LastNameCell.default, props);
      }
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Email",
      dataKey: "email",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_EmailCell.default, props);
      }
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Company",
      dataKey: "company",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_CompanyCell.default, props);
      }
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Country",
      dataKey: "country",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_CountryCell.default, (0, _extends2.default)({}, props, {
          countries: countries
        }));
      }
    }), gapComponent, /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "Sand As",
      dataKey: "sendAsEmail",
      width: 212.5,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_SendAsCell.default, props);
      }
    }), customFieldsWithGap && customFieldsWithGap.length > 0 && customFieldsWithGap.map(function (field) {
      if (tmpColumn === 5) {
        tmpColumn = 0;
      }

      tmpColumn += 1;
      return field.name === 'gap' ? gapComponent : /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
        label: field.name,
        dataKey: field.name,
        width: 212.5,
        columnData: columnData,
        cellRenderer: function cellRenderer(props) {
          return /*#__PURE__*/_react.default.createElement(_CustomFieldCell.default, (0, _extends2.default)({
            label: field.label
          }, props));
        }
      });
    }), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
      label: "",
      dataKey: "",
      width: 50,
      columnData: columnData,
      cellRenderer: function cellRenderer(props) {
        return /*#__PURE__*/_react.default.createElement(_RemoveContactCell.default, (0, _extends2.default)({
          isAbsolute: customFields.length % 5 === 0
        }, props, {
          onRemove: handleRemoveContact
        }));
      }
    }));
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 6
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    className: classes.buttonAddContact,
    onClick: handleAddSingleContact,
    disabled: isAddSingleContactDisable,
    "data-testid": "ProspectingCampaigns.BulkUpload.AddContactButton",
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "plus",
      sx: styles.buttonIcon
    })
  }, "Add contact")), /*#__PURE__*/_react.default.createElement(_ContactsTableErrors.default, {
    control: control,
    contactsCount: fields.length,
    onGoToLine: setScrollIndex
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(ContactsTableController);

exports.default = _default;